import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const DispatchInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Dispatch Section"
    sectionKey="Dispatch"
    backRoute="/sections/dispatch"
  />
);

export default DispatchInternalTransfer;
